import { css } from "styled-components";
import { FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
const partnershipsUniversalMusicCheckBoxStyles = {
    CheckBoxLabel: ()=>css`
		${({ theme  })=>theme.media.up('lg')} {
			::before {
				${BorderRadius({
            all: 'unset'
        })};
				border: unset;
			}

			${FontMixin({
            height: 'base'
        })}
		}

		${({ theme  })=>theme.media.down('sm')} {
			::before {
				${BorderRadius({
            all: 'unset'
        })};
				border: 1px solid ${({ theme  })=>theme.colors.grays.light};
			}

			span {
				${FontMixin({
            size: 'medium',
            height: 'base'
        })}
				color: ${({ theme  })=>theme.colors.grays.darker};
			}
		}
	`
};
export default partnershipsUniversalMusicCheckBoxStyles;

//# sourceMappingURL=partnershipsUniversalMusic.js.map